//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../Weld/Weld.WeldFillStripBuilderList.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"Boundary",0,"Section",0],[0,"BoundaryMethod",1,0],[0,"ChangeViewOrientation",1,0],[0,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[0,"Corner1",1,"Point",0],[0,"Corner2",1,"Point",0],[0,"DistanceTolerance",1,0],[0,"ExtendDistance",1,0],[0,"ExtrudeHeight",1,0],[1,"FillStripList",0,"Weld.WeldFillStripBuilderList",0],[1,"InnerBoundary",0,"Section",0],[0,"Orientation",1,"CoordinateSystem",0],[1,"PlacementFace",0,"ScCollector",0],[0,"SubdivideRegion",1,0],[0,"UseSeedFace",1,0],[0,"Width",1,0],[0,"WidthAlong",1,0]],[[["center","length"],"NewFillStrip",{R_:{newFillStrip:"Weld.WeldFillStripBuilder"}},2,0],[["fillStrip"],"DeleteFillStrip",{},1,0]],[]];
SPLM.Weld.WeldFillBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.WeldFillBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.WeldFillBuilder.BoundaryMethodType = Object.freeze({
    "Rectangle" : "Rectangle", "Curve" : "Curve"});

SPLM.Weld.WeldFillBuilder.WidthAlongType = Object.freeze({
    "Xc" : "Xc", "Yc" : "Yc"});

export default SPLM;